import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import './Control.scss'

const CLASS = 'insights-portal-editor-control'

const Control = props => {
  const className = props.className || CLASS

  const editor = useMemo(() => props.editor || {}, [props.editor])

  const wait = Boolean(editor.state)

  const selectedErrors = useMemo(() => editor.errors?.title || [], [editor.errors?.title])

  const hasErrors = useMemo(() => selectedErrors.length > 0, [selectedErrors])

  const disabled = useMemo(() => !editor.changed || wait || hasErrors, [editor.changed, hasErrors, wait])

  const type = editor.type || ''
  const subjectType = props.subjectType || 'concept'

  const onAdd = () => {
    if (wait) {
      return
    }
    props.onAdd?.()
  }

  const onSave = () => {
    if (!disabled) {
      props?.onSave?.()
    }
  }

  const onCancel = () => {
    props.onCancel?.()
  }

  const saveClass = disabled ? `${className}-save ${className}-save-wait` : `${className}-save`

  const errorControl = hasErrors ? <div className={`${className}-error`}>{selectedErrors.join(' ')}</div> : null

  return ['edit', 'change'].includes(type) ? (
    <div className={className}>
      {errorControl}
      <div className={saveClass} onClick={onSave}>
        {`Save ${subjectType}`}
      </div>
      <div className={`${className}-cancel`} onClick={onCancel}>
        {'Cancel'}
      </div>
    </div>
  ) : (
    <div className={className}>
      <div className={`${className}-add`} onClick={onAdd}>
        {'Add external data'}
      </div>
    </div>
  )
}

Control.propTypes = {
  className: PropTypes.string,
  editor: PropTypes.object,
  subjectType: PropTypes.string,
  onAdd: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onEditorChange: PropTypes.func
}

export default Control
